import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { StopPropagationModule } from '@portal-core/general/directives/stop-propagation/stop-propagation.module';
import { PermissionsTreeComponent } from './permissions-tree.component';

@NgModule({
  declarations: [
    PermissionsTreeComponent
  ],
  imports: [
    CommonModule,
    ErrorsExpansionPanelModule,
    LoaderModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatRippleModule,
    MatTooltipModule,
    MatTreeModule,
    StopPropagationModule
  ],
  exports: [
    PermissionsTreeComponent
  ]
})
export class PermissionsTreeModule { }
